var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_97_2481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9908 3.00925C15.2008 1.21925 12.2992 1.21925 10.5092 3.00925C10.3667 3.15175 9.81834 3.70008 9.67584 3.84258C8.38584 5.13258 8.04 6.99758 8.61 8.61091C6.99667 8.04091 5.1325 8.38591 3.8425 9.67591C3.7 9.81841 3.15167 10.3667 3.00917 10.5092C1.21917 12.2992 1.21917 15.2009 3.00917 16.9909C4.79917 18.7809 7.70084 18.7809 9.49084 16.9909C9.63334 16.8484 10.1817 16.3001 10.3242 16.1576C11.6142 14.8676 11.96 13.0026 11.39 11.3892C13.0033 11.9592 14.8675 11.6142 16.1575 10.3242C16.3 10.1817 16.8483 9.63341 16.9908 9.49091C18.7808 7.70091 18.7808 4.79925 16.9908 3.00925Z",
    fill: "#8BABF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6783 6.32162C13.0275 5.67079 11.9725 5.67079 11.3217 6.32162L6.32167 11.3216C5.67083 11.9725 5.67083 13.0275 6.32167 13.6783C6.9725 14.3291 8.0275 14.3291 8.67833 13.6783L13.6783 8.67829C14.3292 8.02745 14.3292 6.97245 13.6783 6.32162Z",
    fill: "#4671F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_2481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBlue);
export default __webpack_public_path__ + "static/media/link-blue.66328013fc47a40030d9f8e8cce2bbeb.svg";
export { ForwardRef as ReactComponent };